import { useFormik } from "formik"
import * as Yup from "yup"
import React, { useEffect, useState } from "react"
import {
  Button,
  CardTitle,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import { interestFrequency, repaymentSchedule } from "helpers/utils"
import {
  formatAmount,
  getDateOfRepayment,
  getFundRequirementDate,
  getIcdRequestStatus,
} from "helpers/common"
import {
  useIcdRequestsApproveMutation,
  useIcdRequestsRejectMutation,
} from "store/api/icds/icdRequests.api"
import Spinners from "components/Common/Spinner"
import ApproveConfirmationModal from "./confirm/approveConfirmation"
import RejectConfirmationModal from "./confirm/rejectConfirmation"
import AlertAccessModal from "modals/alertAccessModal"
import { useSelector } from "react-redux"
import { usePermission } from "hooks/usePermission"
import { PERMISSIONS } from "helpers/roles"

function IcdOffersDetailsModal({
  icdData,
  requestData,
  open,
  setOpen,
  accepted,
  rejected,
}) {
  const { userType } = useSelector((state) => state.user)
  const [onApprove, { isLoading: isApproving }] =
    useIcdRequestsApproveMutation()
  const [onReject, { isLoading: isRejecting }] = useIcdRequestsRejectMutation()
  const [openAlertModal, setOpenAlertModal] = useState(false)
  const [isToast, setIsToast] = useState(false)
  const [actionType, setActionType] = useState() //APPROVE,REJECT
  const { hasPermission } = usePermission()

  return (
    <React.Fragment>
      <Modal
        isOpen={open}
        toggle={() => {
          setOpen((prev) => !prev)
        }}
        size="lg"
      >
        <ModalHeader
          toggle={() => {
            setOpen((prev) => !prev)
          }}
          className="w-100 header-with-status"
        >
          <div className="d-flex align-items-center justify-content-between">
            <div
              className="d-flex align-items-center gap-2"
              style={{
                lineHeight: 1,
              }}
            >
              <CardTitle className="">
                ICD Request Details:{" "}
                <span> {requestData?.icds?.unique_code} </span>
              </CardTitle>
            </div>

            {requestData && (
              <div className="code-status">
                {getIcdRequestStatus(requestData.status)}
              </div>
            )}
          </div>
        </ModalHeader>
        <ModalBody>
          <Col xl={12}>
            <Row className="mb-2">
              <Col xl={12}>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">Investment Amount</Label>
                    <Input
                      disabled
                      type="text"
                      className="form-control"
                      id="horizontal-firstname-Input"
                      placeholder="Investment Amount"
                      value={`₹ ${formatAmount(requestData?.countered ? requestData?.icds.amount : requestData?.amount)}`}
                    />
                  </Col>

                  <Col xl={6}>
                    <Label className="col-form-label">Date of Repayment</Label>
                    <Input
                      disabled
                      type="text"
                      className="form-control"
                      id="horizontal-email-id "
                      placeholder="Date of Repayment"
                      value={getDateOfRepayment(
                        requestData?.icds?.repayment_date
                      )}
                    />
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">Tenure(in days)</Label>
                    <Input
                      disabled
                      type="text"
                      className="form-control"
                      placeholder="Tenure"
                      value={requestData?.icds.tenure}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Interest Rate (%)</Label>
                    <Input
                      disabled
                      type="text"
                      className="form-control"
                      placeholder="Interest Rate"
                      value={requestData?.icds.interest_rate}
                    />
                  </Col>

                  <Col xl={6}>
                    <Label className="col-form-label">
                      Interest Payment Frequency
                    </Label>
                    <Input
                      disabled
                      type="text"
                      className="form-control"
                      placeholder="Interest Rate"
                      value={
                        requestData &&
                        interestFrequency.find(
                          (item) =>
                            item.key === requestData?.icds.interest_frequency
                        ).label
                      }
                    />
                  </Col>

                  <Col xl={6}>
                    <Label className="col-form-label">
                      Fund Requirement Date
                    </Label>
                    <Input
                      disabled
                      type="text"
                      className="form-control"
                      id="horizontal-email-id "
                      placeholder="Fund Availability Date"
                      value={getFundRequirementDate(
                        requestData?.icds.fund_requirement_date
                      )}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Repayment Schedule</Label>
                    <Input
                      disabled
                      type="text"
                      className="form-control"
                      id="horizontal-email-id "
                      placeholder="Fund Requirement Date"
                      value={
                        requestData &&
                        repaymentSchedule.find(
                          (item) =>
                            item.key === requestData?.icds.repayment_schedule
                        ).label
                      }
                    />
                  </Col>
                  {requestData?.icds.repayment_schedule === "MULTIPLE" && (
                    <Col xl={6}>
                      <Label className="col-form-label">
                        No. Of Installments
                      </Label>
                      <Input
                        name="repayment_terms"
                        type="number"
                        disabled
                        className="form-control"
                        id="repayment_terms"
                        placeholder="Total Installments"
                        value={requestData.icds.repayment_terms}
                      />
                    </Col>
                  )}
                  <Col xl={6}>
                    <Label className="col-form-label">Lock-in (in days)</Label>
                    <Input
                      name="lockin_period"
                      type="number"
                      disabled
                      className="form-control"
                      id="lockin_period"
                      placeholder="Lock-in"
                      value={requestData?.icds.lockin_period}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Notice Period (in days)
                    </Label>
                    <Input
                      name="notice_period"
                      type="number"
                      disabled
                      className="form-control"
                      id="notice_period"
                      placeholder="Notice Period"
                      value={requestData?.icds.notice_period}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="mb-2">
              <CardTitle className="my-4">Investor Details</CardTitle>
              <Col xl={6}>
                <Label
                  htmlFor="horizontal-firstname-Input"
                  className="col-form-label"
                >
                  Investor Name
                </Label>
                <Input
                  disabled
                  name="Name "
                  type="text"
                  className="form-control"
                  id="horizontal-email-id "
                  placeholder="Investor Name"
                  value={requestData?.investor?.name}
                />
              </Col>
              <Col xl={6}>
                <Label
                  htmlFor="horizontal-firstname-Input"
                  className="col-form-label"
                >
                  Email Address
                </Label>
                <Input
                  disabled
                  name="Name "
                  type="text"
                  className="form-control"
                  id="horizontal-email-id "
                  placeholder="Email Address"
                  value={requestData?.investor?.email}
                />
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xl={6}>
                <Label
                  htmlFor="horizontal-firstname-Input"
                  className="col-form-label"
                >
                  Mobile
                </Label>
                <Input
                  disabled
                  name="Name "
                  type="text"
                  className="form-control"
                  id="horizontal-email-id "
                  placeholder="Phone No."
                  value={requestData?.investor?.phone}
                />
              </Col>
              <Col xl={6}>
                <Label
                  htmlFor="horizontal-firstname-Input"
                  className="col-form-label"
                >
                  PAN
                </Label>
                <Input
                  disabled
                  name="Name "
                  type="text"
                  className="form-control"
                  id="horizontal-email-id "
                  placeholder="PAN"
                  value={requestData?.investor?.pan_no}
                />
              </Col>
            </Row>
            {requestData?.countered && (
              <>
                <Row className="mb-2">
                  <CardTitle className="my-4">
                    Counter offer by the investor
                  </CardTitle>
                </Row>

                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">Investment Amount</Label>
                    <Input
                      disabled
                      type="text"
                      className="form-control"
                      id="horizontal-firstname-Input"
                      placeholder="Investment Amount"
                      value={`₹ ${formatAmount(requestData?.amount)}`}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Date of Repayment</Label>
                    <Input
                      disabled
                      type="text"
                      className="form-control"
                      id="horizontal-email-id "
                      placeholder="Date of Repayment"
                      value={getDateOfRepayment(requestData?.repayment_date)}
                    />
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">Tenure(in days)</Label>
                    <Input
                      disabled
                      type="text"
                      className="form-control"
                      placeholder="Tenure"
                      value={requestData?.tenure}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Interest Rate (%)</Label>
                    <Input
                      disabled
                      type="text"
                      className="form-control"
                      placeholder="Interest Rate"
                      value={requestData?.interest_rate}
                    />
                  </Col>

                  <Col xl={6}>
                    <Label className="col-form-label">
                      Interest Payment Frequency
                    </Label>
                    <Input
                      disabled
                      type="text"
                      className="form-control"
                      placeholder="Interest Rate"
                      value={
                        requestData &&
                        interestFrequency.find(
                          (item) => item.key === requestData?.interest_frequency
                        ).label
                      }
                    />
                  </Col>

                  <Col xl={6}>
                    <Label className="col-form-label">
                      Fund Availability Date
                    </Label>
                    <Input
                      disabled
                      type="text"
                      className="form-control"
                      id="horizontal-email-id "
                      placeholder="Fund Availability Date"
                      value={
                        requestData &&
                        getFundRequirementDate(
                          requestData.fund_requirement_date
                        )
                      }
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Repayment Schedule</Label>
                    <Input
                      disabled
                      type="text"
                      className="form-control"
                      id="horizontal-email-id "
                      placeholder="Fund Requirement Date"
                      value={
                        requestData &&
                        repaymentSchedule.find(
                          (item) => item.key === requestData?.repayment_schedule
                        ).label
                      }
                    />
                  </Col>
                  {requestData?.repayment_schedule === "MULTIPLE" && (
                    <Col xl={6}>
                      <Label className="col-form-label">
                        No. Of Installments
                      </Label>
                      <Input
                        name="repayment_terms"
                        type="number"
                        disabled
                        className="form-control"
                        id="repayment_terms"
                        placeholder="Total Installments"
                        value={requestData.repayment_terms}
                      />
                    </Col>
                  )}
                  <Col xl={6}>
                    <Label className="col-form-label">Lock-in (in days)</Label>
                    <Input
                      name="lockin_period"
                      type="number"
                      disabled
                      className="form-control"
                      id="lockin_period"
                      placeholder="Lock-in"
                      value={requestData?.lockin_period}
                    />
                  </Col>
                </Row>
                {requestData?.comments && (
                  <Row className="mb-2">
                    <Col xl={12}>
                      <Label
                        htmlFor="horizontal-firstname-Input"
                        className="col-form-label"
                      >
                        Comments / Notes
                      </Label>
                      <Input
                        disabled
                        name="Name "
                        type="textarea"
                        className="form-control textarea"
                        id="horizontal-email-id "
                        placeholder="Comment"
                        value={requestData?.comments}
                      />
                    </Col>
                  </Row>
                )}
              </>
            )}
            {["COUNTER_OFFER", "DIRECT_ACCEPTANCE"].includes(
              requestData?.status
            ) &&
              icdData.status === "OPEN" &&
              hasPermission(PERMISSIONS.ICD_UPDATE) && (
                <div className="buttons">
                  <Button
                    type="button"
                    className="approve"
                    onClick={() => {
                      if (
                        userType === "ADMIN" &&
                        requestData?.investor?.entity_type === "INDIVIDUAL"
                      ) {
                        setOpenAlertModal(true)
                      } else {
                        setIsToast(true)
                        setActionType("APPROVE")
                      }
                    }}
                  >
                    {isApproving ? <Spinners /> : "Accept"}
                  </Button>
                  <Button
                    type="button"
                    className="reject"
                    onClick={() => {
                      setActionType("REJECT")
                      setIsToast(true)
                    }}
                  >
                    {isRejecting ? <Spinners /> : "Reject"}
                  </Button>
                </div>
              )}
          </Col>
        </ModalBody>
      </Modal>
      {requestData && isToast && actionType === "APPROVE" && (
        <ApproveConfirmationModal
          open={isToast}
          id={requestData.id}
          icdData={requestData?.icds}
          setOpen={setIsToast}
          isLoading={isApproving}
          onClose={() => {
            setIsToast(false)
            setActionType("")
          }}
          onApprove={onApprove}
          onSuccess={accepted}
        />
      )}

      {requestData && isToast && actionType === "REJECT" && (
        <RejectConfirmationModal
          open={isToast}
          id={requestData.id}
          setOpen={setIsToast}
          isLoading={isRejecting}
          onClose={() => {
            setIsToast(false)
            setActionType("")
          }}
          onReject={onReject}
          onSuccess={rejected}
        />
      )}

      {openAlertModal && (
        <AlertAccessModal
          open={openAlertModal}
          onClose={() => setOpenAlertModal(false)}
        />
      )}
    </React.Fragment>
  )
}

export default IcdOffersDetailsModal
